export default __webpack_public_path__ + "static/media/msdm.d01a70c4.png";